import React, { useEffect, useState } from 'react';
import { fetchClubs, fetchClubMembers } from '../util/api/requests';
import { renderSpinner } from '../util/util';
import ClubsDataTable from '../modules/datatables/ClubsDataTable';
import ClubMembersDataTable from '../modules/datatables/ClubMembersDataTable';
import { Row } from 'react-bootstrap';

export const Clubs = () => {
  const [clubs, setClubs] = useState([]);
  const [clubMembers, setClubMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const clubs = await fetchClubs();
        if (clubs) {
          setClubs(clubs);
        }
      } catch (error) {
        console.error('Failed to load clubs:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const members = await fetchClubMembers();
        if (members) {
          setClubMembers(members);
        }
      } catch (error) {
        console.error('Failed to load club members:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <Row className={'justify-content-center mt-3'}>
        <h3 className="ml-3">Klubid</h3>
      </Row>
      {loading && renderSpinner()}
      {clubs.length > 0 && <ClubsDataTable clubs={clubs} />}
      <Row className={'justify-content-center mt-3'}>
        <h3 className="ml-3">Klubiliikmete nimekiri</h3>
      </Row>
      {clubs.length > 0 && (
        <ClubMembersDataTable
          clubMembers={clubMembers}
          paging={true}
          searching={true}
          sortable={true}
        />
      )}
    </>
  );
};
